<template>
  <div class="mainContent db-page">
    <div class="top-control">
      <div class="tab-content">
        <div class="dashboard-hpo" v-if="renderComponent">
          <muuri-grid id="grid" ref="muurigrid" :options="{dragEnabled: false}">
            <muuri-grid-item width="calc(50% - 20px)">
              <inventory-tq-chart @rendered="onChartRendered"></inventory-tq-chart>
            </muuri-grid-item>
            <muuri-grid-item width="calc(50% - 20px)">
              <inventory-vn-chart @rendered="onChartRendered"></inventory-vn-chart>
            </muuri-grid-item>
            <muuri-grid-item width="calc(50% - 20px)">
              <truck-status-chart @rendered="onChartRendered"></truck-status-chart>
            </muuri-grid-item>
            <muuri-grid-item width="calc(50% - 20px)">
              <order-status-chart @rendered="onChartRendered"></order-status-chart>
            </muuri-grid-item>
          </muuri-grid>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import configs from '@/configs';
import clickoutside from '@/directives/clickoutside';
import TruckStatusChart from '@/components/dashboard/TruckStatusChart';
import OrderStatusChart from '@/components/dashboard/OrderStatusChart';
import InventoryTQChart from '@/components/dashboard/InventoryTQChart';
import InventoryVNChart from '@/components/dashboard/InventoryVNChart';
import { MuuriGridItem } from 'vue-muuri-grid';

export default {
  directives: { clickoutside },
  components:{
    'truck-status-chart': TruckStatusChart,
    'order-status-chart': OrderStatusChart,
    'inventory-tq-chart': InventoryTQChart,
    'inventory-vn-chart': InventoryVNChart,
    MuuriGridItem,
  },
  data() {
    return {
      showModal: false,
      renderComponent: true,
      popupModalName: '',
      popupModalTitle: '',
      popupModalHeight: 600,
      layoutTimeout: null,
    }
  },
  methods: {
    onChartRendered() {
      if (this.layoutTimeout) {
        clearTimeout(this.layoutTimeout);
      }
      this.layoutTimeout = setTimeout(() => {
        if (this.$refs.muurigrid && this.$refs.muurigrid.grid) {
          const grid = this.$refs.muurigrid.grid;
          grid.refreshItems();
          grid.layout();
        }
      }, 100);
    }
  },
  mounted() {
    this.$root.$on('zoomChart', (widget) => {
      this.popupModalName = widget.widgetName;
      this.popupModalTitle = widget.widgetTitle;
      this.popupModalHeight = window.innerHeight * 0.6;
    });
  }
}
</script>
<style>
.modal-open{padding-right: 0 !important; }
.modal-backdrop{ z-index: 999998;}
.close:focus{outline:none}
</style>